// extracted by mini-css-extract-plugin
export default {"MonthsNavigation":"J1K-x","activeMonthBox":"zFBCA","wrap":"yMw2y","months":"_54XJ2","month":"lfo0v","year":"PXqHF","skeleton-progress":"b40-5"};